angular.module('rjmNg.api').factory 'ImplementationTags', [
  '$http'
  '$q'
  'serviceUrl'
  'app'
  ($http, $q, serviceUrl, app) ->

    httpArgs =
      headers: {'Content-Type': 'application/json'}
      withCredentials: true

    implementationTags = {}

    implementationTags.getTagTypes = ->
      deferred = $q.defer()

      $http(angular.extend httpArgs,
        url: serviceUrl("/clients/#{app.getClientId()}/tag-types")
        method: 'GET'
      )
      .then ({data}) ->
        deferred.resolve data
      .catch (error) =>
        deferred.reject "Couldn't retrieve tag list."
      deferred.promise

    implementationTags.getTagIdByType = (type) ->
      deferred = $q.defer()
      implementationTags.getTagTypes()
      .then (tags) ->
        tag = _.find(tags, ({name}) ->
          name is type
        )
        if tag
          deferred.resolve tag.id
        else
          deferred.resolve null
      , (error) ->
        deferred.reject error
      deferred.promise

    implementationTags.getTags = () ->
      deferred = $q.defer()
      $http(angular.extend httpArgs,
        url: serviceUrl("/clients/#{app.getClientId()}/tags")
        method: 'GET'
      )
      .then ({data}) ->
        deferred.resolve data
      .catch (error) =>
        deferred.reject "Couldn't get tags."
      deferred.promise

    implementationTags.getTagsForColumn = ({id}) ->
      deferred = $q.defer()
      implementationTags.getTags()
      .then (tags) ->
        tagsForThisColumn = _.chain(tags)
          .filter(({structure_id}) ->
            structure_id is id
          )
          .pluck('type_id')
          .value()
        deferred.resolve tagsForThisColumn
      .catch (error) ->
        deferred.reject error

      deferred.promise

    implementationTags.addTag = (sid, tagId) ->
      deferred = $q.defer()
      $http(angular.extend httpArgs,
        url: serviceUrl("/clients/#{app.getClientId()}/tags")
        method: 'POST'
        data:
          structure_id: sid
          type_id: tagId
      )
      .then ({data}) ->
        deferred.resolve data
      .catch (error) =>
        if error.data?.message?
          deferred.reject error.data.message
        else
          deferred.reject "Couldn't set tag to column."
      deferred.promise

    implementationTags.removeTag = (sid, tagId) ->
      deferred = $q.defer()
      $http(angular.extend httpArgs,
        url: serviceUrl("/clients/#{app.getClientId()}/tags?structure_id=#{sid}&type_id=#{tagId}")
        method: 'DELETE'
      )
      .then ({data}) ->
        deferred.resolve data
      .catch (error) =>
        deferred.reject "Couldn't remove tag from column."
      deferred.promise

    implementationTags
]
